import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import axios from "axios";
import { Drawer } from "@mui/material";
import { Paper, TextareaAutosize, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useEffect, useState, useReducer } from "react";
import { styled } from "@mui/material/styles";
import useWindowDimensions from "../CustomHooks/useWindowdimension";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import ExploreCluster from "../components/Cluster/ExploreCluster";
import StartPost from "../components/Cluster/StartPost";
import { useNavigate } from "react-router-dom";
import Button1 from "../components/ResubleComp/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { ChatState } from "../ChatApp/Context/ChatProvider";
import Cardd from "../components/ClusterContent/ClusterPOST/Card";
const Cluster = () => {
  const { user } = ChatState();
  console.log("userchatstate", user);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { width } = useWindowDimensions();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [text, setText] = useState("");
  const [image, setImage] = useState("");
  const [posts, setPosts] = useState([]);
  const [Comments, setComments] = useState([]);
  const [Comment, setComment] = useState("");
  const [open, setOpen] = useState(false);
  const [opencluster, setOpencluster] = useState(false);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [commentOpen, setCommentopen] = useState(false);
  const [editPost, setEditPost] = useState(false);
  const [update, forceUpdate] = useReducer((x) => x + 1, 0);
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [filter, setFilter] = useState("");
  const [postImage, setPostImage] = useState("");
  const [clearData, setClearData] = useState("");

  console.log("post hai", posts);
  const handleSubmitComment = (event) => {
    event.preventDefault();
    setComments([...Comments, Comment]);
    setComment("");
  };

  const editHandler = () => {
    setEditPost(!editPost);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setPosts([...posts, { text, image }]);
    setText("");
    setImage(null);
    handleClose();
  };
  const clickHandler = () => {
    if (token) {
      setOpen(true);
    } else {
      navigate("/usersignup");
    }
  };

  const handleReply = () => {
    if (!token) {
      navigate("/usersignup");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const clusterHandler = () => {
    if (token) {
      setOpencluster(true);
    } else {
      navigate("/usersignup");
    }
  };
  const clusterClose = () => {
    setOpencluster(false);
  };

  const nameofcurrentUser = localStorage.getItem("userInfo");

  const loggedInUserDetailsGet = localStorage.getItem("TOKEN");

  console.log("loggedInUserDetailsGet", loggedInUserDetailsGet);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  const openpop = Boolean(anchorEl);
  const id = openpop ? "simple-popover" : undefined;

  const openpopEdit = Boolean(anchorE2);
  const idEdit = openpopEdit ? "simple-popover" : undefined;

  const userImage = window.localStorage.getItem("userProfile");

  const moreData = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const editData = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleClosed = () => {
    setAnchorEl(null);
  };

  const handleCloseEdit = () => {
    setAnchorE2(null);
  };
  const token = localStorage.getItem("TOKEN");
  const createPost = async () => {
    setLoaded(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("clusterName", category);
    formData.append("postImage", postImage);
    const url = baseUrl + `/api/post/create`;
    console.log("image before api call", image);
    
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: token,
      },
    });
    setLoaded(false);
    console.log("resultpost", response);
    forceUpdate();
    handleClosed();
    window.localStorage.setItem("postId", response.clusterName);
    if (token) {
      setImage(null);
      handleClose();
    } else {
      alert("please login first");
    }
    setContent("");
    setPostImage(null);
  };

  const getPost = async () => {
    const url = `${baseUrl}/api/post/allPosts`;
    console.log("url", url);
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const asdf = await res.json();
    console.log("total posts", asdf);
    setPosts(asdf);
    setComments(asdf);
    setLoading(false);
  };

  useEffect(() => {
    getPost();
  }, [update]);
  const deleteData = async (postId) => {
    const deleteUrl = `${baseUrl}/api/post/delete/${postId}`;
    const response = await axios.delete(deleteUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    setPosts((prepost) => [...prepost, response]);
    console.log("responsefor dwelete", response);
  };
  const userName = localStorage.getItem("name");
  let userId = localStorage.getItem("userId");

  // const redirectToClusterPage = async (clusterName) => {
  //   localStorage.setItem("clusterId", clusterName);
  //   const url = baseUrl + `/api/cluster/getclusterbyname/${clusterName}`;
  //   const response = await axios.get(url, {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   navigate(`/create-cluster-redirection/${clusterName}`);
  //   return response;
  // };
  const userProfileRedirect = async (userID) => {
    navigate(`/AlluserProfile/${userID}`);
  };

  const filteredPosts = posts.filter((post) =>
    post.clusterName.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Box className="w-full bg-[#f3f2ef]">
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Box sx={{ mb: 3, display: "flex", justifyContent: "space-between" }}>
            <Box
              className="w-full"
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                borderRadius: "20px",
                ml: "-10px",
              }}
            >
              {user?.userProfileImageUrl ? (
                <img
                  src={user.userProfileImageUrl}
                  className="w-12 h-12 ml-4 rounded-full"
                  alt=""
                />
              ) : (
                <AccountCircleIcon sx={{ height: "50px", width: "70px" }} />
              )}
              {user?.name && (
                <Typography variant="h5">
                  {user?.name ? user?.name : "no name"}
                </Typography>
              )}
            </Box>
            <CloseIcon onClick={handleClose} sx={{ cursor: "pointer" }} />
          </Box>

          <TextareaAutosize
            autoFocus
            minRows={2}
            placeholder="What's on your mind?"
            style={{
              width: width > 768 ? "540px" : width > 450 ? "83vw" : "70vw",
              padding: "5px",
              marginLeft: "5px",
              outline: "none",
            }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </DialogContent>
        {postImage && <img src={URL.createObjectURL(postImage)} />}
        {/* <input
          id="file-input"
          type="file"
          onChange={(e) => setPostImage(e.target.files[0])}
        />
        <Typography>Select Image</Typography> */}
        <label
          htmlFor="file-input"
          className="mb-2 cursor-pointer border lg:w-1/5 md:w-1/5 w-24 bg-blue-500 rounded-md text-center py-3 text-white ml-3 lg:text-base md:text-base text-xs"
        >
          Select Image
        </label>
        <input
          id="file-input"
          type="file"
          onChange={(e) => setPostImage(e.target.files[0])}
          className="hidden"
        />
        {/* Easy Crop Comp Above */}
        <DialogActions>
          <Button1
            className=" px-6 py-2 rounded-md bg-blue-500 text-white"
            onClick={createPost}
          >
            {loaded && <CircularProgress color="secondary" size={15} />}
            Post
          </Button1>
        </DialogActions>
      </Dialog>
      <div className="flex gap-5 sm:flex-col flex-col lg:flex-row md:mt-24 items-center lg:pl-24 lg:pr-24 lg:pb-5 max-sm:mt-8">
        <div className="m-auto max-w-xl lg:w-[90%] md:w-[90%] w-[98%] mt-4 lg:mt-4 md:mt-4">
          {/* Click to start a post */}

          <StartPost
            Item={Item}
            width={width}
            clickHandler={clickHandler}
            token={token}
            userImage={userImage}
          />

          {/* Click to start a post comp above */}

          <Box className="mt-3 max-w-xl">
            <div className="flex justify-center items-center">
              {loading && <CircularProgress color="secondary" />}
            </div>
            <Box className="w-full flex flex-col-reverse">
              {filteredPosts.length === 0 && !loading ? (
                <Typography
                  variant="body1"
                  className="text-red-500 text-center mt-4 font-bold text-xl"
                >
                  Cluster not found with this name.
                </Typography>
              ) : (
                filteredPosts.map((post) => (
                  <Cardd
                    post={post}
                    width={width}
                    token={token}
                    baseUrl={baseUrl}
                    commentOpen={commentOpen}
                    handleReply={handleReply}
                    forceUpdate={forceUpdate}
                    userId={userId}
                    navigate={navigate}
                    setPosts={setPosts}
                    handleClose={handleClose}
                    userName={userName}
                    setCommentopen={setCommentopen}
                  />
                ))
              )}
            </Box>
          </Box>
        </div>
        <div className="w-1/4 fixed right-0 top-[104px] p-4 clusterExplore">
          <ExploreCluster
            opencluster={opencluster}
            clusterClose={clusterClose}
            CloseIcon={CloseIcon}
            width={width}
            clusterHandler={clusterHandler}
            token={token}
            baseUrl={baseUrl}
            setPosts={setPosts}
            filter={filter}
            setFilter={setFilter}
            posts={posts}
          />
        </div>

        {/* drawer for mobile view */}
        <button
          variant="outlined"
          sx={{
            borderRadius: "10px",
            backgroundColor: "#258480",
            color: "white",
            fontWeight: "600",
          }}
          className="clusterDrawer text-white lg:hidden md:block xl:hidden 2xl:hidden rounded-lg
          bg-cyan-600 p-2 w-full fixed bottom-0
          "
          onClick={() => {
            setIsDrawerOpen(true);
          }}
        >
          Explore Clusters
        </button>
        <Drawer
          anchor="top"
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
        >
          <ExploreCluster
            opencluster={opencluster}
            clusterClose={clusterClose}
            CloseIcon={CloseIcon}
            width={width}
            clusterHandler={clusterHandler}
          />
        </Drawer>
      </div>
      {/* Popover right hand side dropdown */}
      <Popover
        id={id}
        anchorEl={anchorEl}
        onClose={handleClosed}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Typography sx={{ p: 2 }}>profile</Typography>
        <Typography sx={{ p: 2 }}>
          {" "}
          <a href="/userlogin">
            {" "}
            <span>Logout</span>{" "}
          </a>{" "}
        </Typography>
      </Popover>
    </Box>
  );
};
export default Cluster;
